if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.form = document.querySelector('[id^="MainProduct-"] form[data-type="add-to-cart-form"]');
        if (!this.form) return;

        this.mainButton = this.form.querySelector('[type="submit"]');
        this.button = this.querySelector('[data-sticky-button]');
        this.status = this.querySelector('[data-sticky-status]');
        this.qtyBadge = this.querySelector('[data-sticky-qty]');
        this.shipping = this.querySelector('[data-sticky-shipping]');
        this.quantityInput =
          document.querySelector(`input[name="quantity"][form="${this.form.id}"]`) ||
          this.form.querySelector('input[name="quantity"]');
        this.freeShippingQuantity = parseInt(this.dataset.freeShippingQuantity, 10) || 2;
        this.phase = 'idle';
        this.timers = [];

        if (!this.mainButton || !this.button) return;

        this.onButtonClick = this.onButtonClick.bind(this);
        this.onQuantityChange = this.onQuantityChange.bind(this);
        this.updateHeight = this.updateHeight.bind(this);
        this.onScroll = this.onScroll.bind(this);

        this.button.addEventListener('click', this.onButtonClick);
        if (this.quantityInput) this.quantityInput.addEventListener('change', this.onQuantityChange);
        this.onQuantityChange();

        // A scroll check (rather than IntersectionObserver alone) also catches jumps
        // straight past the button, e.g. anchor links or restored scroll position.
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();

        if (window.matchMedia('(max-width: 749px)').matches && !this.classList.contains('sticky-atc--hide-mobile')) {
          document.body.classList.add('sticky-atc-offset');
        }
        this.updateHeight();
        window.addEventListener('resize', this.updateHeight);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribers = [
            subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
              if (this.phase === 'loading') this.setPhase('added');
            }),
            subscribe(PUB_SUB_EVENTS.cartError, () => {
              if (this.phase === 'loading') {
                this.setPhase('idle');
                this.scrollToForm();
              }
            }),
          ];
        }
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        if (this.unsubscribers) this.unsubscribers.forEach((unsubscribe) => unsubscribe());
        if (this.quantityInput) this.quantityInput.removeEventListener('change', this.onQuantityChange);
        window.removeEventListener('resize', this.updateHeight);
        this.clearTimers();
        document.body.classList.remove('sticky-atc-visible', 'sticky-atc-offset');
      }

      onScroll() {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          this.toggle(this.mainButton.getBoundingClientRect().bottom < 0);
        });
      }

      toggle(visible) {
        if (visible === this.isVisible) return;
        this.isVisible = visible;
        this.classList.toggle('is-visible', visible);
        this.toggleAttribute('inert', !visible);
        this.setAttribute('aria-hidden', String(!visible));
        document.body.classList.toggle('sticky-atc-visible', visible);
      }

      updateHeight() {
        document.documentElement.style.setProperty('--sticky-atc-height', `${this.offsetHeight}px`);
      }

      onQuantityChange() {
        const quantity = this.quantityInput ? parseInt(this.quantityInput.value, 10) || 1 : 1;

        if (this.qtyBadge) {
          this.qtyBadge.textContent = `× ${quantity}`;
          this.qtyBadge.hidden = quantity < 2;
        }

        if (this.shipping) {
          this.shipping.dataset.state = quantity >= this.freeShippingQuantity ? 'unlocked' : 'locked';
        }
      }

      onButtonClick() {
        if (this.phase !== 'idle') return;

        const mainUnavailable =
          this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true';
        if (mainUnavailable) {
          this.scrollToForm();
          return;
        }

        this.setPhase('loading');
        // Submitting through the main form keeps quantity and subscription choices in sync.
        this.mainButton.click();
        this.timers.push(
          setTimeout(() => {
            if (this.phase === 'loading') this.setPhase('idle');
          }, 8000)
        );
      }

      setPhase(phase) {
        this.phase = phase;
        this.button.dataset.phase = phase;
        this.button.setAttribute('aria-busy', String(phase === 'loading'));

        const label = this.button.querySelector(`.sticky-atc__label--${phase}`);
        if (this.status) this.status.textContent = phase === 'idle' || !label ? '' : label.dataset.text;

        if (phase === 'added') {
          this.clearTimers();
          this.timers.push(setTimeout(() => this.setPhase('idle'), 1800));
        }
      }

      clearTimers() {
        this.timers.forEach((id) => clearTimeout(id));
        this.timers = [];
      }

      scrollToForm() {
        const target = this.form.closest('.product__buy-buttons') || this.form;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  );
}
